import React, { useEffect, useMemo, useRef } from 'react'
import { Button, Input, message, Radio, RadioChangeEvent, Select } from 'antd'
import { SGeneralForms, SSegmentedTabs } from 'shj-components'
import {
  generalSave,
  generalUpdateById,
  getProductEnums,
  getSpecialCodesList,
} from '@/services/product.ts'
import { StandardTable } from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/step3/addOrEdit/standard'
import { useSetState } from 'ahooks'
import { isEmpty } from 'lodash-es'
import { replaceRule, trimStr } from '@/utils/data.ts'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal.tsx'

const AddOrEdit = props => {
  const { editRef, isStand, setLoading, readOnly } = props
  const ref = useRef()
  const tableRef = useRef<any>({ getData: undefined })
  const [state, setState] = useSetState<any>({
    chooseType: [],
    chooseLimit: [],
    chooseTypeKey: '',
    initValues: {},
    specialCodeList: [],
  })

  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    budgetRule: '',
    filterRule: '',
    key: '',
  })

  const onFormRef = () => {
    const { onFormRef } = ref.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    console.log(props.record, 'props.record---general')

    !isStand && getOptions()
    if (!isEmpty(props.record)) {
      onFormRef()?.setFieldsValue({ ...props.record })
      const { budgetRule, filterRule } = props.record?.ruleJson || {}
      setRuleModal({ budgetRule, filterRule })
      setState({ chooseTypeKey: props.record.sonChooseType, initValues: props.record })
    } else {
      setState({ chooseTypeKey: 'CUSTOMER' })
      onFormRef()?.setFieldsValue({ sonChooseType: 'CUSTOMER', sonChooseConfine: 'ONE_CHOOSE' })
    }
  }, [props.record])

  const chooseLimitRes = useMemo(() => {
    if (state.chooseTypeKey !== 'GEN_STANDARD') {
      return state.chooseLimit.filter(item => item.value !== 'ALL')
      // onFormRef()?.setFieldValue('sonChooseConfine', data[0]?.value)
    }
    return state.chooseLimit
  }, [state.chooseType, state.chooseTypeKey])

  const getOptions = async () => {
    const chooseType = await getProductEnums('com.shj.saas.plus.product.enums.GenChooseTypeEnum')
    const chooseLimit = await getProductEnums(
      'com.shj.saas.plus.product.enums.GenChooseConfineEnum'
    )
    let specialCodeList: any = await getSpecialCodesList({
      data: {},
    })
    specialCodeList = specialCodeList.map(item => ({ label: item.showName, value: item.code }))
    setState({
      chooseType: chooseType.map(item => ({ label: item.description, value: item.key })),
      chooseLimit: chooseLimit.map(item => ({ label: item.description, value: item.key })),
      specialCodeList: specialCodeList,
    })
  }

  const onOpenRule = key => {
    setRuleModal({ open: true, key })
  }

  const onFinish = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        setLoading?.(true)
        const apiUrl = values.id ? generalUpdateById : generalSave
        const newValues = {
          ...values,
          ruleJson: {
            filterRule: ruleModal.filterRule,
            // budgetRule: ruleModal.budgetRule,//需求决定暂时不上
          },
          generalStandardList: tableRef.current?.getData?.(),
        }
        apiUrl({ data: newValues })
          .then((res: any) => {
            message.success(res.message || '操作成功')
            props.onCancel?.()
            props.fn?.()
          })
          .finally(() => setLoading?.(false))
      })
  }

  if (editRef) editRef.onFinish = onFinish

  return (
    <>
      <SGeneralForms
        initialValues={props.record?.id && state.chooseType.length && { ...state.initValues }}
        ref={ref}
        layout={'vertical'}
        titleMode={'edit'}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                spanCol: 24,
                label: '通项名称',
                name: 'itemName',
                hidden: isStand,
                required: true,
                rules: [{ required: true, message: '通项名称不能为空' }],
                comConfig: {
                  showCount: true,
                  maxLength: 15,
                  onChange: e => onFormRef()?.setFieldValue('itemName', trimStr(e.target.value)),
                },
              },
              {
                name: 'specialCode',
                label: '特项代码',
                hidden: isStand,
                spanCol: 24,
                children: (
                  <Select
                    allowClear
                    placeholder="请选择"
                    options={state.specialCodeList}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={e => onFormRef()?.setFieldValue('specialCode', e)}
                  />
                ),
              },
              {
                name: 'sonChooseType',
                hidden: isStand,
                label: '子集选择方式',
                spanCol: 24,
                // children: <SSegmentedTabs style={{padding: 0}} onChange={(key) => setState({chooseTypeKey: key})}
                //                           options={state.chooseType}/>
                children: (
                  <Radio.Group
                    options={state.chooseType}
                    onChange={({ target: { value } }: RadioChangeEvent) =>
                      setState({ chooseTypeKey: value })
                    }
                  />
                ),
              },
              {
                name: 'sonChooseConfine',
                hidden: isStand,
                label: '子集选择限制',
                spanCol: 24,
                children: <Radio.Group options={chooseLimitRes} />,
                // children: <SSegmentedTabs style={{padding: 0}} options={chooseLimitRes}/>
              },
              {
                name: 'chooseLimit',
                label: '多选个数上限',
                spanCol: 24,
                hidden: isStand,
                required: true,
                isDeps: true,
                deps: form => form.getFieldValue('sonChooseConfine') === 'MORE_CHOOSE',
                rules: [{ required: true, message: '多选个数上限不能为空' }],
                type: 'inputNumber',
                comConfig: { min: 2, precision: 0, max: 9999 },
              },
              {
                label: '子集产品过滤',
                isDeps: true,
                deps: form => state.chooseTypeKey !== 'GEN_STANDARD',
                spanCol: 24,
                children: (
                  <div>
                    {!readOnly && (
                      <Button onClick={() => onOpenRule('filterRule')}>编辑规则</Button>
                    )}
                    {
                      <Input.TextArea
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        disabled
                        style={{ marginTop: 6 }}
                        value={replaceRule(ruleModal.filterRule)}
                        placeholder={ruleModal?.filterRule ? ruleModal?.filterRule : '暂无规则'}
                      />
                    }
                  </div>
                ),
              },
              // {
              //   label: '预算量规则',
              //   hidden: isStand,
              //   spanCol: 24,
              //   children: (
              //     <div>
              //       <Button onClick={() => onOpenRule('budgetRule')}>编辑规则</Button>
              //       {ruleModal?.budgetRule && (
              //         <Input.TextArea
              //           autoSize={{ minRows: 1, maxRows: 4 }}
              //           disabled
              //           style={{ marginTop: 6 }}
              //           value={replaceRule(ruleModal.budgetRule)}
              //         />
              //       )}
              //     </div>
              //   ),
              // },
            ],
          },
        ]}
      />
      {ruleModal.open && (
        <RulesModal
          modalProps={{ ...ruleModal, value: ruleModal[ruleModal.key] || '' }}
          onCancel={() => setRuleModal({ open: false })}
          type={ruleModal.key === 'budgetRule' ? 'generalBudgetItem' : 'productFilterRule'}
          onOk={(value: string) => setRuleModal({ [ruleModal.key]: value })}
        />
      )}
    </>
  )
}

export default AddOrEdit
